import Header from "@components/Header/Header";
import QRBottomSheet from "@components/QRBottomSheet/QRBottomSheet";
import { IDetectedBarcode, Scanner } from '@yudiel/react-qr-scanner';
import { useState, useRef, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router';
import { useTranslation } from "react-i18next";
import {
    Container,
    ScannerContainer,
    BlackBackgroundDiv,
    BlackSpacerDiv,
    ScannerContentContainer,
    ScannerFrame,
    BottomActionsContainer,
    ScanningText,
    QRButton
} from "./QRScanner.styles";
import usePublicAddress from "@hooks/usePublicAddress";

const QRScanner = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useTranslation();
    const [isActive, setIsActive] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const publicAddress = usePublicAddress();
    const isNavigatingRef = useRef(false);

    // Get the source from location state
    const from = location.state?.from ?? '/home';
    const to = location.state?.to ?? '/home';

    const handleMouseDown = () => {
        setIsActive(true);
    };

    const handleMouseUp = () => {
        setIsActive(false);
    };

    const handleSheetClose = () => {
        setIsOpen(false);
    }

    const handleScan = (result: IDetectedBarcode[]) => {
        // Guard against empty results and prevent double navigation
        if (!result || result.length === 0 || isNavigatingRef.current) {
            return;
        }

        // Set navigation lock
        isNavigatingRef.current = true;
        navigate(to, { state: { address: result[0].rawValue } });
    }

    // Cleanup navigation lock on unmount
    useEffect(() => {
        return () => {
            isNavigatingRef.current = false;
        };
    }, []);

    return (
        <Container>
            <Header title={t('p2p.qrScanner.header')} showBackButton onBackClick={() => navigate(from)} />
            <ScannerContainer>
                <BlackSpacerDiv />
                <Scanner
                    onScan={handleScan}
                    components={{
                        audio: false,
                        torch: false,
                        finder: false,
                        zoom: true
                    }}
                    styles={{
                        // The library container defaults to overflow: hidden with a 1/1
                        // aspect ratio, which clips BottomActionsContainer (anchored
                        // 100px below ScannerFrame) on phone-width viewports.
                        container: {
                            overflow: 'visible',
                        },
                        video: {
                            width: '100%',
                        },
                    }}
                >
                    <ScannerContentContainer>
                        <ScannerFrame>
                            <BottomActionsContainer>
                                <ScanningText>
                                    {t('p2p.qrScanner.scanningText')}
                                </ScanningText>
                                <QRButton
                                    $isActive={isActive}
                                    onClick={() => setIsOpen(true)}
                                    onMouseDown={handleMouseDown}
                                    onMouseUp={handleMouseUp}
                                    onTouchStart={handleMouseDown}
                                    onTouchEnd={handleMouseUp}
                                >
                                    {t('p2p.qrScanner.myQRCode')}
                                </QRButton>
                            </BottomActionsContainer>
                        </ScannerFrame>
                    </ScannerContentContainer>
                </Scanner>
                <BlackBackgroundDiv />
            </ScannerContainer>
            <QRBottomSheet
                isOpen={isOpen}
                onClose={handleSheetClose}
                qrValue={publicAddress}
                height="320px"
            />
        </Container>
    )
}

export default QRScanner